import React, { useEffect } from 'react';

const GenesysBot = ({ config }) => {
  useEffect(() => {
    const loadGenesysBot = () => {
      const { deploymentId, orgId, widgetTheme } = config;

      // Validate required fields
      if (!deploymentId || !orgId) {
        console.error('Genesys Bot configuration is incomplete. Please provide "deploymentId" and "orgId".');
        return;
      }

      // Inject Genesys Widgets script dynamically
      const genesysScript = document.createElement('script');
      genesysScript.type = 'text/javascript';
      genesysScript.async = true;
      genesysScript.src = `https://apps.mypurecloud.com/widgets/9.0/widgets.min.js`;

      genesysScript.onload = () => {
        // Initialize Genesys Widgets
        window.Genesys = window.Genesys || {};
        window.Genesys.widgets = window.Genesys.widgets || {};
        window.Genesys.widgets.config = {
          deploymentId,
          orgId,
          logLevel: 'DEBUG',
          theme: widgetTheme || 'light', // Optional: Allows passing a custom theme
        };

        console.log(`Genesys Bot initialized for deployment ID: ${deploymentId}`);
      };

      document.body.appendChild(genesysScript);
    };

    loadGenesysBot();

    // Cleanup: Remove script and clear Genesys widgets configuration on unmount
    return () => {
      const genesysScript = document.querySelector('script[src="https://apps.mypurecloud.com/widgets/9.0/widgets.min.js"]');
      if (genesysScript) document.body.removeChild(genesysScript);

      if (window.Genesys && window.Genesys.widgets) {
        window.Genesys.widgets.config = null;
      }
      console.log('Genesys Bot cleanup complete.');
    };
  }, [config]);

  return (
    <div id="genesys-bot-container">
      <p>Loading Genesys Cloud Assistant...</p>
    </div>
  );
};

export default GenesysBot;
